import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FeldService } from '../service';

@Component({
  selector: 'fa-kt-feld-detail',
  templateUrl: './feld-detail.component.html',
  styleUrls: ['./feld-detail.component.css'],
})
export class FeldDetailComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  constructor(public feld: FeldService) {}
}
